var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab tab2",
    class: {
      active: _vm.selected == 1
    },
    on: {
      "click": function($event) {
        _vm.onTabSelect(1)
      }
    }
  }, [_c('span', [_vm._v("待处理")])]), _vm._v(" "), _c('div', {
    staticClass: "tab tab2",
    class: {
      active: _vm.selected == 2
    },
    on: {
      "click": function($event) {
        _vm.onTabSelect(2)
      }
    }
  }, [_c('span', [_vm._v("已完成")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == 1),
      expression: "selected == 1"
    }],
    staticClass: "content"
  }, [_c('order-list', {
    attrs: {
      "url": "/api/orders/my/pending",
      "emptyTitle": "暂无待处理订单",
      "role": "customer"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == 2),
      expression: "selected == 2"
    }],
    staticClass: "content"
  }, [_c('order-list', {
    attrs: {
      "url": "/api/orders/my/finish",
      "emptyTitle": "暂无已完成订单",
      "role": "customer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "jumpFormDiv"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-00bd54dc","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/MyOrderList.vue
// module id = 218
// module chunks = 0